"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const styles = (theme) => ({
    root: {
        borderRadius: 0,
    },
    title: {
        backgroundColor: '#39A9B0',
        color: theme.palette.common.white,
        padding: '16px 30px',
    },
    content: {
        padding: '0px 0px',
    },
});
const StyledCard = (props) => {
    const { children, classes, title } = props;
    return (react_1.default.createElement(Card_1.default, { className: classes.root },
        react_1.default.createElement(CardHeader_1.default, { title: title, titleTypographyProps: { variant: 'h6' }, className: classes.title }),
        react_1.default.createElement(CardContent_1.default, { className: classes.content }, children)));
};
StyledCard.propTypes = {
    title: prop_types_1.default.string.isRequired,
};
exports.default = styles_1.withStyles(styles)(StyledCard);
